webpackJsonp([79611799117203],{

/***/ 256:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(221);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(256);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(114);
	var isArguments = __webpack_require__(113);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ribbonStyle = __webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var positionMapping = {
	  left: [_ribbonStyle.RibbonStyle.leftStyle, _ribbonStyle.RibbonStyleWrapper.leftStyle],
	  right: [_ribbonStyle.RibbonStyle.rightStyle, _ribbonStyle.RibbonStyleWrapper.rightStyle],
	  'left-bottom': [_ribbonStyle.RibbonStyle.leftBottomStyle, _ribbonStyle.RibbonStyleWrapper.leftBottomStyle],
	  'right-bottom': [_ribbonStyle.RibbonStyle.rightBottomStyle, _ribbonStyle.RibbonStyleWrapper.rightBottomStyle]
	};
	
	var colorMapping = {
	  red: _ribbonStyle.RibbonStyle.redColor,
	  orange: _ribbonStyle.RibbonStyle.orangeColor,
	  black: _ribbonStyle.RibbonStyle.blackColor,
	  green: _ribbonStyle.RibbonStyle.greenColor
	};
	
	var GitHubForkRibbon = function GitHubForkRibbon(_ref) {
	  var _ref$position = _ref.position,
	      position = _ref$position === undefined ? 'right' : _ref$position,
	      href = _ref.href,
	      target = _ref.target,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'red' : _ref$color,
	      children = _ref.children,
	      other = _objectWithoutProperties(_ref, ['position', 'href', 'target', 'color', 'children']);
	
	  var positionStyle = positionMapping[position] || [_ribbonStyle.RibbonStyle.rightStyle, _ribbonStyle.RibbonStyleWrapper.rightStyle];
	  var colorStyle = colorMapping[color] || _ribbonStyle.RibbonStyle.redColor;
	
	  if (positionStyle[0] === _ribbonStyle.RibbonStyle.rightStyle) {
	    position = 'right';
	  }
	
	  var ribbonStyle = _extends({}, _ribbonStyle.RibbonStyle.baseStyle, positionStyle[0], colorStyle);
	
	  var wrapperStyle = _extends({}, _ribbonStyle.RibbonStyleWrapper.baseStyle, positionStyle[1]);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, other, {
	      className: 'github-fork-ribbon-wrapper ' + position,
	      style: wrapperStyle }),
	    _react2.default.createElement(
	      'div',
	      { className: 'github-fork-ribbon',
	        style: ribbonStyle },
	      _react2.default.createElement(
	        'a',
	        { href: href,
	          target: target,
	          style: _ribbonStyle.RibbonStyle.urlStyle },
	        children
	      )
	    )
	  );
	};
	
	exports.default = global.RibbonStyle = GitHubForkRibbon;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	* "Fork me on GitHub" CSS ribbon v0.1.1 | MIT License
	* https://github.com/simonwhitaker/github-fork-ribbon-css
	*
	* 20150116 Lee: use css source for inline style react component.
	*/
	var RibbonStyle = exports.RibbonStyle = {
	
	  baseStyle: {
	    /* The right and left classes determine the side we attach our banner to */
	    position: 'absolute',
	
	    /* Add a bit of padding to give some substance outside the "stitching" */
	    padding: '2px 0',
	
	    /* Set the base colour */
	    backgroundColor: '#a00',
	
	    /* Set a gradient: transparent black at the top to almost-transparent black at the bottom */
	    // backgroundImage: '-webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.15)))',
	    // backgroundImage: '-webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
	    // backgroundImage: '-moz-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
	    // backgroundImage: '-ms-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
	    // backgroundImage: '-o-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
	    backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
	
	    /* Add a drop shadow */
	    WebkitBoxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.5)',
	    MozBoxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.5)',
	    boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.5)',
	
	    /* Set the font */
	    font: '700 13px "Helvetica Neue", Helvetica, Arial, sans-serif',
	
	    zIndex: '9999',
	    pointerEvents: 'auto'
	  },
	
	  urlStyle: {
	    /* Set the text properties */
	    color: '#fff',
	    textDecoration: 'none',
	    textShadow: '0 -1px rgba(0, 0, 0, 0.5)',
	    textAlign: 'center',
	
	    /* Set the geometry. If you fiddle with these you'll also need
	       to tweak the top and right values in .github-fork-ribbon. */
	    width: '200px',
	    lineHeight: '20px',
	
	    /* Set the layout properties */
	    display: 'inline-block',
	    padding: '2px 0',
	
	    /* Add "stitching" effect */
	    borderWidth: '1px 0',
	    borderStyle: 'dotted',
	    // borderColor: '#fff',
	    borderColor: 'rgba(255, 255, 255, 0.7)'
	  },
	
	  redColor: {
	    backgroundColor: '#a00'
	  },
	
	  orangeColor: {
	    backgroundColor: '#f80'
	  },
	
	  blackColor: {
	    backgroundColor: '#333'
	  },
	
	  greenColor: {
	    backgroundColor: '#090'
	  },
	
	  leftStyle: {
	    top: '42px',
	    left: '-43px',
	
	    WebkitTransform: 'rotate(-45deg)',
	    MozTransform: 'rotate(-45deg)',
	    msTransform: 'rotate(-45deg)',
	    OTransform: 'rotate(-45deg)',
	    transform: 'rotate(-45deg)'
	  },
	
	  rightStyle: {
	    top: '42px',
	    right: '-43px',
	
	    WebkitTransform: 'rotate(45deg)',
	    MozTransform: 'rotate(45deg)',
	    msTransform: 'rotate(45deg)',
	    OTransform: 'rotate(45deg)',
	    transform: 'rotate(45deg)'
	  },
	
	  leftBottomStyle: {
	    top: '80px',
	    left: '-43px',
	
	    WebkitTransform: 'rotate(45deg)',
	    MozTransform: 'rotate(45deg)',
	    msTransform: 'rotate(45deg)',
	    OTransform: 'rotate(45deg)',
	    transform: 'rotate(45deg)'
	  },
	
	  rightBottomStyle: {
	    top: '80px',
	    right: '-43px',
	
	    WebkitTransform: 'rotate(-45deg)',
	    MozTransform: 'rotate(-45deg)',
	    msTransform: 'rotate(-45deg)',
	    OTransform: 'rotate(-45deg)',
	    transform: 'rotate(-45deg)'
	  }
	};
	
	var RibbonStyleWrapper = exports.RibbonStyleWrapper = {
	
	  baseStyle: {
	    width: '150px',
	    height: '150px',
	    position: 'absolute',
	    overflow: 'hidden',
	    top: 0,
	    zIndex: '9999',
	    pointerEvents: 'none'
	  },
	
	  fixedStyle: {
	    position: 'fixed'
	  },
	
	  leftStyle: {
	    left: 0
	  },
	
	  rightStyle: {
	    right: 0
	  },
	
	  leftBottomStyle: {
	    position: 'fixed',
	    top: 'inherit',
	    bottom: 0,
	    left: 0
	  },
	
	  rightBottomStyle: {
	    position: 'fixed',
	    top: 'inherit',
	    bottom: 0,
	    right: 0
	  }
	};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(135);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(112);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(122);
	
	var _HelmetConstants = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(46);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(32);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(141);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Footer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _footerModule = __webpack_require__(246);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	var _iconFacebook = __webpack_require__(324);
	
	var _iconFacebook2 = _interopRequireDefault(_iconFacebook);
	
	var _iconInstagram = __webpack_require__(325);
	
	var _iconInstagram2 = _interopRequireDefault(_iconInstagram);
	
	var _iconTwitter = __webpack_require__(326);
	
	var _iconTwitter2 = _interopRequireDefault(_iconTwitter);
	
	var _iconYoutube = __webpack_require__(327);
	
	var _iconYoutube2 = _interopRequireDefault(_iconYoutube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import checkIcon from './icon-check.svg';
	// import xIcon from './icon-x.svg';
	
	var cx = _bind2.default.bind(_footerModule2.default);
	var propTypes = {};
	var netlifySolutions = [{ name: 'Netlify', href: 'https://netlify.com' }, { name: 'NetlifyCMS', href: 'https://www.netlifycms.org/' }, { name: 'GoTell', href: 'https://github.com/netlify/gotell' }, { name: 'Gotiator', href: 'https://github.com/netlify/gotiator' }, { name: 'AWS Lambda', href: 'https://aws.amazon.com/lambda/ ' }, { name: 'GoTrue', href: 'https://github.com/netlify/gotrue' }];
	var icons = [_iconFacebook2.default, _iconInstagram2.default, _iconYoutube2.default, _iconTwitter2.default];
	
	// addon button
	// <span className={ cx('addon', 'error') }>
	//   <img src={ xIcon } />
	// </span>
	
	function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: cx('footer') },
	    _react2.default.createElement(
	      'div',
	      { className: cx('first', 'top-row') },
	      _react2.default.createElement(
	        'div',
	        { className: cx('content') },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'JAM Commerce'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A headless e-commerce solution for JAMstack sites'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/netlify/gocommerce' },
	          'View the code on GitHub'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: cx('solutions') },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Other JAMStack solutions'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: cx('solutions-container') },
	          netlifySolutions.map(function (_ref) {
	            var name = _ref.name,
	                href = _ref.href;
	            return _react2.default.createElement(
	              'p',
	              { key: name },
	              _react2.default.createElement(
	                'a',
	                { href: href },
	                name
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('about', 'top-row') },
	      _react2.default.createElement(
	        'div',
	        { className: cx('content') },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://jamstack.org/' },
	            'About JAMStack'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.heavybit.com/library/podcasts/jamstack-radio/' },
	            'JAMstack Radio Podcast'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '' },
	            'JAMStack Online Training'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://jamstack.org/community/' },
	            'JAMStack Meetup'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '' },
	            'MIT License'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '' },
	            'See the Code'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '' },
	            'Jobs'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '' },
	            'Contact Us'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('newsletter', 'top-row') },
	      _react2.default.createElement(
	        'div',
	        { className: cx('content') },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'JAMStack Newsletter'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Join millions of people worldwide and stay up to date with our (non-spammy) newsletter'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: cx('input') },
	          _react2.default.createElement('input', { placeholder: 'your@email.com' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { disabled: true, type: 'submit' },
	          'Subscribe'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('bottom') },
	      _react2.default.createElement(
	        'div',
	        { className: cx('icons') },
	        icons.map(function (icon) {
	          return _react2.default.createElement(
	            'div',
	            { className: cx('icon'), key: icon },
	            _react2.default.createElement('img', { src: icon })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: cx('created-by') },
	        _react2.default.createElement(
	          'h4',
	          { className: cx('title') },
	          'Created By ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.netlify.com' },
	            'Netlify'
	          )
	        ),
	        _react2.default.createElement(
	          'h5',
	          { className: cx('byline') },
	          'Template by',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.realworldreact.com ' },
	            'Real World React'
	          )
	        )
	      )
	    )
	  );
	}
	Footer.displayName = 'Footer';
	Footer.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"_3O29ujeMQuiLZU0bq61j6r","top-row":"_2Y3PaddLf36C29cgiOKV5o","first":"RNRnWrHrAQvAeOsznzOux","content":"_3mljNXX0X_96ESVY2-8uj8","solutions":"_3Scw3DY357WHK2Etot4OGM","solutions-container":"KoWp9ijmRIZb2zsydieJo","about":"_1HWo06hDNAPPM9Q2c3WG9Q","newsletter":"_1jES0hlO4wDJuS7PbOKubU","input":"_1yPSSqrrlKWtr4uQ0Ds95J","error":"_3mhevV3-ljgjM85P0RXpDX","success":"_1R5qMLFBaMYio1IJsBhHQD","addon":"HSsT4icpSwCSuPqhQv6r0","bottom":"aMy6aIgAvmg8YPlhjNLvg","icons":"_1VWLtCNMLJjjalQN_H397j","icon":"_3-4ZC6enwFDHiO3aYKz9iK","created-by":"_1RECJazYd2Aw06Uk8gixAJ"};

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAXCAYAAADduLXGAAAABGdBTUEAALGPC/xhBQAAAYdJREFUOBHtUztOAzEQtR3vLrs5AFQhUVqEREGH6FGOwAE4AQV9TgAVEldISU2BaCMKqKJVEhEakGiiaOP98t4KWxbiCIzknfH4zZvxjFeKX9I0jVytVsfQB3Vd96G1gkgpH6SPnc/ne/Df4eAsDEMFYHsMW6zX64myYDJiXXe73REYVZZlYrvdugVc7sCLxWIfjKPNZiMsYxRFIo5jkSQJOSNtmaH7nU4nqaqqdcEm6wSbaVmWJJ06cFEUAQEUZBAopYEeDwaD59aJjytDa22sk5qlYNW+T89msyEuNTTGHNlaHUCJ0+VyuSsDqUxh3jRSXwRBcIm6hK33J0hqpW9YUhzGojLVlcam9oGOFYYNxn1YUsoLhmwN2VCKjxVsHS9NdmT/5Cjv0dssz3P2+ZxBPIRuEHwL+x0MNQJf3bjTND1B9CNTWzBYD3u93otN51oHx451Wo1aY2tT+2Df/6f9D/bb4t4zBiHxTNuBcCh4z/zN3NAY5MCwPzCEJ44bQmCJiX5xY+Ubpu/C+IZ4iRwAAAAASUVORK5CYII="

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABGdBTUEAALGPC/xhBQAAA+FJREFUSA2llktIVGEUx+/oOM6kVioi0TjqoNkIEUKJmx6booIUFNoFRhGRmiRIQdGiVhWZkERI9Fi1yDIkLKRF4UaqlZkKvh0xlHE0fI7jOP3O5d6YZuY2Q31w+V7/8z/nO+d857smJawNDw/nJCcnHw0EAg0mk6l4c3MzDBE5TUhIkMXv4JsYd9nt9qlQlEmfBINBy+Tk5FVAtTabLYu5giIFQR1i2As2MTFRxa6urs4i9yA3N/c2sn4RUhnGxsasjJ+npaWd8vv9is/n60fwK2sLAoqzbYd0n9VqLTabzcri4uKLjY2NM4WFhT5VfnR09KbH4wlyktWJiYk6t9tti5M4Aob8JXjWhA/e6wIwTU1N2bG+Dwu2cdQ6p9PZEiEZY2F6enoLHGeJnz8/P/8RnqnH5c1ra2tziO5R0Fanaf2Gi5Ji8EXdhqNxfn4+6PV6g+Pj4xfhSUTRoMZ72owfr0gGEfAePVDhTL29vekZGRknCegBsNlgZ8B0M+7A8gXmFj5FEoBmhSeAss/MixjXmtncKZt8y+HkMseiYwSymbQuslgsKhGCyvr6+jncMTg0NFSPxfeBSh4HlpeXW0UOPq8YD7bULAOtReQq1pxAQRvxspEtbnCvEZqEwMG4kmzcTd+OoRV5eXm3NB69U/nkAGZ9JbwnITJJwRZRgHVvIT8P0Q8dRwbdWVpaepyamnoc3ENOXCqu0/dDe/Wqhi7oY9xRCUE+RONctOpQBYJxOBzTkFdjgBtcIRaX67LhvaESXHAoKSlJwZ0vKROSihGtoKBglv12iRX4gxEAbcFQCfvp4k+EJ4yEtfURwdGyjXCGShD0SBZhqdNIWFvPExz4qKcVzN+UdEsd4yRVAwMDmdEUkb5ZKKgSHO1TNIysGSqhSLaTtmMENZcMe8Kt/sMdpPcOYvaUfQe4EYx5Y6TEMIVdLtccRLVcuDbuQzlZtpf5K9wiMXLSyz3Jod6tMK+htM8bKsECfU+Nnj6RnrTthLgKomYs3oXlDZCr7wYprrA+iKvqKapdoXLaWOUTfrnxgwzk5qZFAYqid5TvnpWVlQoUHAafwb3xMP5IQewoKSmJegHh2ioKwPebATcRvFYmZYwtjNfDlWmueMa6fDEbCZEMqEyyju9eAi7oJHALKSkpxbjmQkyGOACcoIb3xEUcvcT0vSpC3bkhtV9etP95GeXxgusyPD7tLbkmCtRKycbvN556JAHtZ+8L308Bxdnkjd9PurvC33hViZCIH6lB8rciR/2nvxXhwcAZ4tsS8bcim3pDmZ0H6ghJ0MiaCwF9y7CXLKL18d3lNB+kQoeCfwHDrTvZFb23cwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAXCAYAAAAYyi9XAAAABGdBTUEAALGPC/xhBQAAA5NJREFUSA2tlktoU1EQhm/eiWmIaKDYQmNSglSxIn1YcC2iXSm6UHdC1wUlULvqwiJUF1JfxY1WN+5ciA8oXShFLA1olhJTUhuFaIMtrUl6kyZ+c03Sm5g22nrg5J47Z2b+mX/mnBuDss0xPz/vWFtbO4GbYEEptJmMprvZbPZBa2trRO86HA4729vbUwYRhkIhi9vt7ggEAu/0SvXW0Wi0y2q13jabzd25XE4BWLHZbArrRdY3AL7Fnh+di2pOjfu8vhENMBKJ7Lfb7W9RHPD5fGP1gGS/CPYCh55MJlNhYjKZFKPRqAAYY91cKBS+GQyGbuYPo2iyeYTI3BjficViwQrrGi8EaMNmtBaYqEumgCkWi2Uvrz8BHEcWVFX1qAYI8q58Pq8wjSiNzM3N3Z+dnW0U41oD/Q4Ae1ZXV2ttl2UCik8XPgcRLlHXSQ0QYbQIqEUG530oTQM8kEgk/gCGpgA6CpGXnddaEJiCbpbMLlGqIXQKWg3j8fhuoglDUbMUXwZroUQhi68YPoWSZ4jDUL7g9/vPsfeoXoYSFDoh9Ls0p/xogPKCo/M4GQfYrI9cGkAMiVK6bwHwL0wzJgf0euKjehQBpwHsKe1plFKvM9SkiWhekVkFT9IA6XRaawTAPQR1iGddMAEQSvGbLIHJUyKVYW9oaLi+tLSkkmE5699b67+lOq9LNl8BJnX+pNfSMkQwAdh3srPqN7e7LlL+Xu9HA4TjBMJr0iRCw/8Y4ocSpSjJlN5fKUOFtr1JrYaojyodut0hVxwlmOLsRfW+9J5hoDCGkkp0ffDvk5ptdYgtfu4xK5pQDyiH9CBAV6DBUuR/S3jcywr36+tkMvm82kGZUtloaWmZpEufOJ1Ou9RgK0M6Ex8pMgx2dnZmq31UAEr6NE7/ysrKQ6mjw+HQbv1qo43eJUg57DA0SO1maultmAb36DGi7SXSsxg21aungAmVNN4oDdhfC0xkFRnqlbjKPgCSAtRVr55CY7Fu8nm7rPdTvTbwIXXTwq7l5eU0NO6EkjYAThLxaeSN8nHdCFCykvbnjs1A47DX6x1GVtGV1YBmsnBh0E+jnGLtxwE22qHV7tBqA9mTjIoXeh7bl8yr0PhXf0/KNYSKwzi6QDa9TPnemaRupewEiGMjt0eB9Wd0J9h7TGe/qQ5qs/cyYEmJP1Q7PB7PPpzJN+w4c09xL4Fski6eIaOPZLRYsvmX5y9nz8sgyTQlCAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAZCAYAAABU+vysAAAABGdBTUEAALGPC/xhBQAAAv5JREFUSA29l01rE1EUhmcmkzQh0Y0lrpKQNhHEqkizqApVEEGwW0UUXBS6VcFuXbqsP8A/4EJBELrQRV0ofmDAVbQu0nysEoxdaEK+JonPCZMQW2PujKEXLjP33nPf+55z3jsn0TWF1uv1DAWzsSa6rnfHLtoL+qhBNps95vP5ljn4TLfbjfIMsu6n+wAbNVV+B0NsW/QGvQpOwTCMjGVZr+fm5r7JorQ+eiaTCdEeYrDq9XpDsiAAo13m3DZxYm9vtVq/Op3OY4/H8yASidRNDtMLhcKjYDC4VqvVtHq97vY8R/tw+hDO369Wqz423hESJyDzmYFXInCQDTIaEqgTlZMG4bkyMzNz4CTEYUhofr8/gF7OG+TuOi+OAiGeoCVHe8YZCxk4XJVreapjdcbZ7Zu3w7nbbrczpmlq3LJ9Nk4m7CCkJCJ+7ofyXlv9awAs4s01+juJjltCti5nDScCFRJoqkc08slkshmLxZ6Vy+WLzEl637shJOeDG3T1xSQ9nkEIU6lUG0JPo9HoBSEEyQ9CSFKo2iDjUbeegIpXfUKVSmUZMjcZV5yQmRqRAU+JUDwef4J2tkXMqk3dUhFxZ2fnNB+odSKyRGQUd2na1IgUi8UFTr0HgRtoJOi0VAgRKdGOUkTuh67m8/njjO+CcYsrHGo2m27qVcfEg11AZlWusdjgrc5VXYGAVO5V9t+GwGGXBPpVGT390HO53CtEddn+woE9uclt4KpagUDApJz3a8bkXX+3kKsOxqak5LkTdQscHsh3wmw0Gv9FQrAQtkTlhQHoW8JqMZB55aaSyklgcibRsIjKRwO1fwX0DeV40r6pr/PzQyL6qVQqfemHgR9Hi4T6JSk6IqKbhreTWEuRhESd81YSicTWMB+IdgkiG5A4ZzPt539apCQNInJb6CL2bdKyPj8/vymkh0RkkE6nveFw+CxGlxgusPkoRAI81X8nCNCeBoacU6N/R5w5nqLLLSr4z4HpH0QGk6NPQBx97Eb3jr7jzD//2/wGHW9yQb8/EHcAAAAASUVORK5CYII="

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Footer = __webpack_require__(208);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Footer).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _views;
	
	exports.default = Body;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Text = __webpack_require__(213);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Image = __webpack_require__(211);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var views = (_views = {}, _views[_Image2.default.displayName] = _Image2.default, _views[_Text2.default.displayName] = _Text2.default, _views);
	
	var propTypes = {
	  view: _propTypes2.default.string
	};
	
	function Body(_ref) {
	  var view = _ref.view,
	      props = _objectWithoutProperties(_ref, ['view']);
	
	  var View = views[view];
	  if (!View) {
	    return null;
	  }
	  return _react2.default.createElement(View, props);
	}
	
	Body.displayName = 'Body';
	Body.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Image;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _menuModule = __webpack_require__(74);
	
	var _menuModule2 = _interopRequireDefault(_menuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_menuModule2.default);
	var propTypes = {
	  categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    img: _propTypes2.default.string
	  })).isRequired
	};
	
	function Image(_ref) {
	  var categories = _ref.categories,
	      closeMobileMenu = _ref.closeMobileMenu;
	
	  return _react2.default.createElement(
	    'div',
	    { className: cx('image') },
	    categories.map(function (_ref2) {
	      var title = _ref2.title,
	          img = _ref2.img,
	          alt = _ref2.alt,
	          _ref2$href = _ref2.href,
	          href = _ref2$href === undefined ? '#' : _ref2$href;
	      return _react2.default.createElement(
	        'div',
	        { className: cx('item'), key: title },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: href, onClick: closeMobileMenu },
	          _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { alt: alt, src: img })
	          )
	        )
	      );
	    })
	  );
	}
	Image.displayName = 'Image';
	Image.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Menu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _menuModule = __webpack_require__(74);
	
	var _menuModule2 = _interopRequireDefault(_menuModule);
	
	var _Body = __webpack_require__(210);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_menuModule2.default);
	var propTypes = {
	  children: _propTypes2.default.element,
	  isOpen: _propTypes2.default.bool,
	  onMouseLeave: _propTypes2.default.func
	};
	
	var exampleCopy = '\n  Note: This is an example site. All links point to the same route.\n';
	function Menu(_ref) {
	  var children = _ref.children,
	      isOpen = _ref.isOpen,
	      onMouseLeave = _ref.onMouseLeave;
	
	  var menuClasses = {
	    menu: true,
	    open: isOpen
	  };
	  return _react2.default.createElement(
	    'div',
	    {
	      className: cx(menuClasses),
	      onMouseLeave: onMouseLeave
	    },
	    children,
	    _react2.default.createElement(
	      'div',
	      null,
	      exampleCopy
	    )
	  );
	}
	
	Menu.Body = _Body2.default;
	
	Menu.displayName = 'Menu';
	Menu.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Text;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _menuModule = __webpack_require__(74);
	
	var _menuModule2 = _interopRequireDefault(_menuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_menuModule2.default);
	var propTypes = {
	  categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    items: _propTypes2.default.arrayOf({
	      title: _propTypes2.default.string,
	      href: _propTypes2.default.string
	    })
	  }))
	};
	
	function Text(_ref) {
	  var categories = _ref.categories,
	      closeMobileMenu = _ref.closeMobileMenu;
	
	  return _react2.default.createElement(
	    'div',
	    { className: cx('text') },
	    categories.map(function (_ref2) {
	      var title = _ref2.title,
	          sub = _ref2.sub;
	      return _react2.default.createElement(
	        'div',
	        { className: cx('category'), key: title },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            title
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'div',
	          { className: cx('content') },
	          sub.map(function (_ref3) {
	            var title = _ref3.title,
	                _ref3$href = _ref3.href,
	                href = _ref3$href === undefined ? '#' : _ref3$href;
	            return _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                className: cx('item'),
	                key: title,
	                to: href,
	                onClick: closeMobileMenu
	              },
	              _react2.default.createElement(
	                'p',
	                null,
	                title
	              )
	            );
	          })
	        )
	      );
	    })
	  );
	}
	Text.displayName = 'Text';
	Text.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Menu = __webpack_require__(212);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Menu).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_XzlWXGXanps7605jae8R","open":"_3K_sW9muCO14uY_nBXrj99","image":"HGcKvyLLBsEdVJzLFut6N","item":"_1yaXrPZ-V4TSX1hmyMePeI","text":"_3nfKiS6PHuDrTgOIAeH7La","category":"_2eVo5CvOmyyZexFlB9U0J7","content":"_3e-kUQQn-GtlEnh7Gzge-y"};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.Nav = Nav;
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(40);
	
	var _reactRedux = __webpack_require__(6);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reselect = __webpack_require__(11);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _redux2 = __webpack_require__(217);
	
	var _navModule = __webpack_require__(247);
	
	var _navModule2 = _interopRequireDefault(_navModule);
	
	var _cart = __webpack_require__(329);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _hamburger = __webpack_require__(330);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	var _menuClose = __webpack_require__(331);
	
	var _menuClose2 = _interopRequireDefault(_menuClose);
	
	var _backArrow = __webpack_require__(328);
	
	var _backArrow2 = _interopRequireDefault(_backArrow);
	
	var _Menu = __webpack_require__(214);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _redux3 = __webpack_require__(17);
	
	var _redux4 = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preventDefault = function preventDefault(e) {
	  return e && e.preventDefault();
	};
	var createBoundFunc = _lodash2.default.memoize(function (name, e, ac, dispatch) {
	  return _lodash2.default.flow(e, function () {
	    return ac(name);
	  }, dispatch);
	}, function (name, e, ac) {
	  return name + ac;
	});
	
	var cx = _bind2.default.bind(_navModule2.default);
	var mapStateToProps = (0, _reselect.createSelector)(_redux2.isMenuOpenSelector, _redux2.directoriesSelector, _redux2.directorySelector, _redux2.categoriesSelector, _redux4.numInCartSelector, _redux3.isSignedInSelector, _redux3.nameSelector, _redux2.isMobileMenuOpenSelector, function (isMenuOpen) {
	  var directories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var currentDirectory = arguments[2];
	  var categories = arguments[3];
	  var numInCart = arguments[4];
	  var isSignedIn = arguments[5];
	  var name = arguments[6];
	  var isMobileMenuOpen = arguments[7];
	  return {
	    categories: categories,
	    currentDirectory: currentDirectory,
	    directories: directories,
	    isMenuOpen: isMenuOpen,
	    isSignedIn: isSignedIn,
	    name: name,
	    numInCart: numInCart,
	    isMobileMenuOpen: isMobileMenuOpen
	  };
	});
	
	function mapDispatchToProps(dispatch) {
	  var dispatchers = (0, _redux.bindActionCreators)({
	    clickOnSignIn: _redux2.clickOnSignIn,
	    mouseLeaveMenu: _redux2.mouseLeaveMenu,
	    closeSubMenu: _redux2.closeSubMenu,
	    openMobileMenu: _redux2.openMobileMenu,
	    closeMobileMenu: _redux2.closeMobileMenu
	  }, dispatch);
	  dispatchers.dispatch = dispatch;
	  return function () {
	    return dispatchers;
	  };
	}
	
	function mergeProps(stateProps, dispatchProps) {
	  var _stateProps$directori = stateProps.directories,
	      directories = _stateProps$directori === undefined ? [] : _stateProps$directori;
	  var dispatch = dispatchProps.dispatch;
	
	  var clickOnSubNavActions = directories.reduce(function (dispatchers, _ref) {
	    var title = _ref.title;
	
	    dispatchers[title] = createBoundFunc(title, preventDefault, _redux2.clickOnSubNav, dispatch);
	
	    return dispatchers;
	  }, {});
	  var hoverOnSubNavActions = directories.reduce(function (dispatchers, _ref2) {
	    var title = _ref2.title;
	
	    dispatchers[title] = createBoundFunc(title, _lodash2.default.noop, _redux2.hoverOnSubNav, dispatch);
	    return dispatchers;
	  }, {});
	
	  return _extends({}, stateProps, dispatchProps, {
	    clickOnSubNavActions: clickOnSubNavActions,
	    hoverOnSubNavActions: hoverOnSubNavActions
	  });
	}
	
	var propTypes = {
	  categories: _propTypes2.default.array,
	  clickOnSignIn: _propTypes2.default.func.isRequired,
	  clickOnSubNavActions: _propTypes2.default.object,
	  currentDirectory: _propTypes2.default.object,
	  directories: _propTypes2.default.array,
	  hoverOnSubNavActions: _propTypes2.default.object,
	  isMenuOpen: _propTypes2.default.bool,
	  isSignedIn: _propTypes2.default.bool,
	  mouseLeaveMenu: _propTypes2.default.func.isRequired,
	  closeSubMenu: _propTypes2.default.func.isRequired,
	  name: _propTypes2.default.string,
	  numInCart: _propTypes2.default.number,
	  openMobileMenu: _propTypes2.default.func.isRequired,
	  closeMobileMenu: _propTypes2.default.func.isRequired,
	  isMobileMenuOpen: _propTypes2.default.bool
	};
	
	function Nav(_ref3) {
	  var categories = _ref3.categories,
	      clickOnSignIn = _ref3.clickOnSignIn,
	      clickOnSubNavActions = _ref3.clickOnSubNavActions,
	      currentDirectory = _ref3.currentDirectory,
	      directories = _ref3.directories,
	      hoverOnSubNavActions = _ref3.hoverOnSubNavActions,
	      isMenuOpen = _ref3.isMenuOpen,
	      isSignedIn = _ref3.isSignedIn,
	      mouseLeaveMenu = _ref3.mouseLeaveMenu,
	      closeSubMenu = _ref3.closeSubMenu,
	      name = _ref3.name,
	      numInCart = _ref3.numInCart,
	      openMobileMenu = _ref3.openMobileMenu,
	      closeMobileMenu = _ref3.closeMobileMenu,
	      isMobileMenuOpen = _ref3.isMobileMenuOpen;
	
	  var signBtn = void 0;
	  if (isSignedIn) {
	    signBtn = _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        to: '/account',
	        className: cx('signin-link'),
	        onClick: closeMobileMenu
	      },
	      name
	    );
	  } else {
	    signBtn = _react2.default.createElement(
	      _gatsbyLink2.default,
	      { onClick: clickOnSignIn, to: '/signin', className: cx('signin-link') },
	      'Sign In'
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: cx('navbar') },
	    _react2.default.createElement(
	      'nav',
	      { className: cx('top') },
	      _react2.default.createElement(
	        'div',
	        { className: cx('hamburger'), onClick: openMobileMenu },
	        _react2.default.createElement('img', { alt: 'menu hamburger', src: _hamburger2.default })
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/', onClick: closeMobileMenu },
	        _react2.default.createElement(
	          'div',
	          { className: cx('title') },
	          'JAM Commerce'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: cx('account') },
	        _react2.default.createElement(
	          'li',
	          null,
	          signBtn
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: cx('cart'),
	              to: '/cart',
	              style: { backgroundImage: 'url(' + _cart2.default + ')' },
	              onClick: closeMobileMenu
	            },
	            _react2.default.createElement(
	              'span',
	              { className: cx('num-in-cart') },
	              typeof numInCart === 'number' ? numInCart : 0
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'nav',
	      { className: cx('bottom', { open: isMobileMenuOpen }) },
	      _react2.default.createElement(
	        'div',
	        { className: cx('mobile-menu-meta') },
	        _react2.default.createElement(
	          'div',
	          null,
	          isMenuOpen && _react2.default.createElement(
	            'button',
	            { className: cx('back-button'), onClick: closeSubMenu },
	            _react2.default.createElement('img', { src: _backArrow2.default }),
	            ' Back'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: closeMobileMenu },
	          _react2.default.createElement('img', { alt: 'menu close', src: _menuClose2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        directories.map(function (_ref4) {
	          var title = _ref4.title,
	              href = _ref4.href;
	          return _react2.default.createElement(
	            'a',
	            {
	              className: cx('item-link'),
	              href: href,
	              key: title,
	              onClick: clickOnSubNavActions[title],
	              onMouseEnter: function onMouseEnter() {
	                return !isMobileMenuOpen && hoverOnSubNavActions[title]();
	              }
	            },
	            _react2.default.createElement(
	              'li',
	              { className: cx('item') },
	              title
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'a',
	          {
	            className: cx('item-link'),
	            href: '/women/shoes',
	            onClick: closeMobileMenu
	          },
	          _react2.default.createElement(
	            'li',
	            { className: cx('item') },
	            'Sale'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: cx('mobile-menu-account') },
	        signBtn,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/cart', onClick: closeMobileMenu },
	          'View cart'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Menu2.default,
	      {
	        isOpen: isMenuOpen,
	        onMouseLeave: function onMouseLeave() {
	          return !isMobileMenuOpen && mouseLeaveMenu();
	        }
	      },
	      _react2.default.createElement(_Menu2.default.Body, {
	        categories: categories,
	        closeMobileMenu: closeMobileMenu,
	        view: currentDirectory.view
	      })
	    )
	  );
	}
	
	Nav.displayName = 'Nav';
	Nav.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(Nav);

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5UcmlhbmdsZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJNb2JpbGUvSG9tZS1NZW51T3Blbi1OT1QtU0lHTkVELUlOIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjUuMDAwMDAwLCAtNjcuMDAwMDAwKSI+CiAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiBmaWxsPSIjMDAwMDAwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMS4wMDAwMDAsIDczLjAwMDAwMCkgc2NhbGUoLTEsIDEpIHJvdGF0ZSg5MC4wMDAwMDApIHRyYW5zbGF0ZSgtMzEuMDAwMDAwLCAtNzMuMDAwMDAwKSAiIHBvaW50cz0iMzEgNjcgMzcgNzkgMjUgNzkiPjwvcG9seWdvbj4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI5cHgiIGhlaWdodD0iMzBweCIgdmlld0JveD0iMCAwIDI5IDMwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0My4yICgzOTA2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+aWNvbnMvY2FydDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJNYWluLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlJFU09VUkNFUyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI5Mi4wMDAwMDAsIC04NC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Imljb25zL2NhcnQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI5Mi4wMDAwMDAsIDg1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiMwMDAwMDAiIHg9IjAiIHk9IjkiIHdpZHRoPSIyOSIgaGVpZ2h0PSIyMCI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgY3g9IjE0LjUiIGN5PSI5LjUiIHJ4PSI2LjUiIHJ5PSI5LjUiPjwvZWxsaXBzZT4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMjMgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQzLjIgKDM5MDY5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5NZW51PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ik1haW4tRGVzaWduIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTW9iaWxlL0hvbWUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMy4wMDAwMDAsIC0xNC4wMDAwMDApIiBmaWxsPSIjMDAwMDAwIj4KICAgICAgICAgICAgPGcgaWQ9Ik5hdmlnYXRpb25CYXIiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ik1lbnUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjAwMDAwMCwgMTQuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0xMyIgeD0iMCIgeT0iMCIgd2lkdGg9IjIzIiBoZWlnaHQ9IjQuNDczNjg0MjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTEzIiB4PSIwIiB5PSI2LjI2MzE1Nzg5IiB3aWR0aD0iMjMiIGhlaWdodD0iNC40NzM2ODQyMSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTMiIHg9IjAiIHk9IjEyLjUyNjMxNTgiIHdpZHRoPSIyMyIgaGVpZ2h0PSI0LjQ3MzY4NDIxIj48L3JlY3Q+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Nav = __webpack_require__(215);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Nav2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTMgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5YIC0gQ2xvc2U8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iTW9iaWxlL0hvbWUtTWVudU9wZW4tTk9ULVNJR05FRC1JTiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzOC4wMDAwMDAsIC02My4wMDAwMDApIj4KICAgICAgICA8cGF0aCBkPSJNMzQ3LjAwODc3Miw2OS41IEwzNTEsNzMuNDkxMjI4MSBMMzQ4LjQ5MTIyOCw3NiBMMzQ0LjUsNzIuMDA4NzcxOSBMMzQwLjUwODc3Miw3NiBMMzM4LDczLjQ5MTIyODEgTDM0MS45OTEyMjgsNjkuNSBMMzM4LDY1LjUwODc3MTkgTDM0MC41MDg3NzIsNjMgTDM0NC41LDY2Ljk5MTIyODEgTDM0OC40OTEyMjgsNjMgTDM1MSw2NS41MDg3NzE5IEwzNDcuMDA4NzcyLDY5LjUgWiIgaWQ9IlgtLS1DbG9zZSIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"navbar":"_2ADPvmzR6oqCZgdvCJDn3u","top":"_2NVe397lKPAf62s7Kywjeq","hamburger":"_3cGfae3PDGDGFG80_L9vrK","title":"_1HH_CnAlOe9im4FRUFWozF","account":"tYAq4ou27eFOyVx17Hnda","signin-link":"_1Vf1GxuvtWP23k2y7jqK7F","cart":"_1xTKI3Sva2q1NwFrlKdUzs","num-in-cart":"_1dijyKJHKxwwta7I5Ms26h","bottom":"_2TV8zxy1leaPN_Km5WED1_","open":"_1zcufGVqSIS2CptFZc0T0m","item-link":"_3HsfsvYNQuV5duIdKx3mBM","item":"_2YFdiHV8-TfeVEX5jSmGtO","mobile-menu-meta":"_39RxNIx6mkuYlGEHWtWd_8","mobile-menu-account":"Z78AP9o2PzVFMnQKCxz68"};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TemplateWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactHelmet = __webpack_require__(121);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactGithubForkRibbon = __webpack_require__(274);
	
	var _reactGithubForkRibbon2 = _interopRequireDefault(_reactGithubForkRibbon);
	
	__webpack_require__(271);
	
	var _mainModule = __webpack_require__(250);
	
	var _mainModule2 = _interopRequireDefault(_mainModule);
	
	var _redux = __webpack_require__(22);
	
	var _Nav = __webpack_require__(216);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Footer = __webpack_require__(209);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_mainModule2.default);
	var mapStateToProps = null;
	var mapDispatchToProps = {
	  appMounted: _redux.appMounted
	};
	
	var propTypes = {
	  appMounted: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.func
	};
	
	var TemplateWrapper = exports.TemplateWrapper = function (_PureComponent) {
	  _inherits(TemplateWrapper, _PureComponent);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.componentDidMount = function componentDidMount() {
	    this.props.appMounted();
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      { className: cx('main') },
	      _react2.default.createElement(_reactHelmet2.default, {
	        meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }],
	        title: 'JamCommerce'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: cx('github-outer-wrapper') },
	        _react2.default.createElement(
	          _reactGithubForkRibbon2.default,
	          {
	            color: 'green',
	            href: 'https://github.com/realworldreact/jamcommerce',
	            position: 'left',
	            target: '_blank'
	          },
	          'Fork me on GitHub'
	        )
	      ),
	      _react2.default.createElement(_Nav2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: cx('content') },
	        children()
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return TemplateWrapper;
	}(_react.PureComponent);
	
	TemplateWrapper.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TemplateWrapper);

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"QCOZFfAPaTtuJOqS3UtbX","content":"_3Yppz0UDmn5LbQBUpIBh","github-outer-wrapper":"_3S_J8dBo6K7KYccrVbZj_G"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-363e441bc5f77daea614.js